import { AbstractControl, ValidationErrors, ValidatorFn, FormGroup } from '@angular/forms';
import { zxcvbn } from '@zxcvbn-ts/core';

export function passwordStrengthValidator(minScore: number = 3): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value || '';
    if (!value) return null;
    const score = zxcvbn(value).score;
    return score < minScore ? { weakPassword: true, score } : null;
  };
}

export function confirmPasswordValidator(
  passwordKey = 'password',
  confirmKey = 'confirmPassword'
): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const pw = group.get(passwordKey)?.value;
    const confirm = group.get(confirmKey)?.value;
    return pw && confirm && pw !== confirm ? { passwordMismatch: true } : null;
  };
}
